export default {
  contact: {
    hero: {
      eyebrow: 'Contacto',
      title: 'Hable con nosotros',
      lead: 'Ya sea información inicial, planificación concreta o una visita in situ: esperamos su mensaje.',
    },
    info: {
      partner: 'Su socio en tecnología de seguridad',
      owner: 'Propietario',
      address: 'Dirección',
      phone: 'Teléfono',
      email: 'Email',
      hours: 'Horario',
      area: 'Zona de servicio',
      viewAreas: 'Ver todas las zonas de servicio',
    },
    form: {
      title: 'Solicitud de proyecto',
      lead: 'Rellene el formulario. Le responderemos enseguida.',
      customerType: 'Particular o empresa *',
      select: 'Seleccione',
      privat: 'Particular',
      gewerbe: 'Empresa',
      name: 'Nombre *',
      company: 'Empresa',
      phone: 'Teléfono',
      email: 'Email *',
      projectLocation: 'Ubicación del proyecto',
      objectType: 'Tipo de inmueble',
      objEfh: 'Vivienda unifamiliar',
      objMfh: 'Edificio de viviendas',
      objLaden: 'Comercio / tienda',
      objBuero: 'Oficina / consulta',
      objGastronomie: 'Hostelería',
      objLager: 'Almacén / logística',
      objWerkstatt: 'Taller / industria',
      objSonstige: 'Otro',
      service: 'Servicio deseado',
      svcBeratung: 'Primera consulta',
      svcPlanung: 'Planificación y presupuesto',
      svcInstallation: 'Instalación y configuración',
      svcErweiterung: 'Ampliación de sistema existente',
      svcWartung: 'Mantenimiento / soporte',
      svcCare: 'Solicitud SSG Care',
      systemStatus: 'Estado del sistema',
      stNeu: 'Sistema nuevo',
      stBestehend: 'Ampliar sistema existente',
      stAustausch: 'Sustitución completa',
      stUnsicher: 'Aún no lo sé',
      message: 'Mensaje',
      messagePlaceholder: 'Describa brevemente su proyecto o preguntas...',
      maxChars: 'Máximo 500 caracteres',
      fileUpload: 'Subir archivo',
      fileHint: 'Fotos, planos u otros documentos (opcional)',
      fileNote: 'Nota: las subidas se tratan como «Uncollectable».',
      callback: 'Franja horaria preferida',
      callbackNone: 'No deseo que me llamen',
      vormittag: 'Mañana',
      nachmittag: 'Tarde',
      abend: 'Noche',
      consent: 'He leído la política de privacidad y acepto el tratamiento de mis datos para esta solicitud. *',
      success: 'Gracias por su solicitud. Le responderemos enseguida.',
      submit: 'Enviar solicitud',
      submitting: 'Enviando...',
    },
  },
};